import { render, staticRenderFns } from "./BookmarkDialogue.vue?vue&type=template&id=13a13048&scoped=true&"
import script from "./BookmarkDialogue.vue?vue&type=script&lang=js&"
export * from "./BookmarkDialogue.vue?vue&type=script&lang=js&"
import style0 from "./BookmarkDialogue.vue?vue&type=style&index=0&id=13a13048&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../.yarn/__virtual__/vue-loader-virtual-783d792af9/0/cache/vue-loader-npm-15.10.0-778eb54c35-1bf6c9ffea.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a13048",
  null
  
)

export default component.exports